import { FC, useEffect, useState } from "react";
import { RequestForMovementDataProvider } from "../../../../Services/DataProviders/RequestForMovementDataProvider";
import { LoadingStatus } from "../../../../@types/enumsGlobal";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { PluginWrapper, ToolbarWrapper } from "../../../../components/plugins";
import { Spinner } from "../../../../components/spiner/Spinner";
import { IDosageByStoreDTO } from "../../../../libs/coreapi-dto/documents/requestForMovement";
import useGridFilter, { CreateSelectorGridFilter } from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { useUserContext } from "../../../../system/providers/userContextProvider";

const DosageByStoreGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();

    const requestForMovementDataProvider = new RequestForMovementDataProvider(appCtx.coreApiService);
    const [data, setData] = useState<IDosageByStoreDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.Completed);
    const [totalCount, setTotalCount] = useState(0);
    const [, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter ?? CreateSelectorGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>(props.data ?? []);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(true);

    useEffect(() => {
        setIsSubmitting(true)
        requestForMovementDataProvider.getDistinctDosageViewByStore(gridFilter, (data, totalCount) => {
            setData(data)
            setTotalCount(totalCount)
            data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
            setIsSubmitting(false)
        })
    }, [gridFilter])

    return (
        <PluginWrapper>
                    {isSubmitting ? (
                        <Spinner /> ) : (
                        <DefaultGrid
                            showQuantity
                            gridId={props.gridId}
                            data={data}
                            getView={(gridFilter,callback) => {
                                requestForMovementDataProvider.getDistinctDosageViewByStore(gridFilter, (e, t) => {
                                    callback(e)
                                })
                            }}
                            loadingStatus={loadingStatus}
                            setLoadingStatus={setLoadingStatus}
                            separator
                            singleDirectory
                            totalCount={totalCount}
                            filter={gridFilter}
                            dataProvider={requestForMovementDataProvider}
                            plugin={props.plugin}
                            selectedItem={selectedItem}
                            selectedItems={selectedItems}
                            multipleSelect={props.multipleSelect}
                            onSelect={(row) => {
                                setSelectedItem(row)
                                props.onSelect?.(row)
                            }}
                            onMultipleSelect={(rows) => {
                                setSelectedItems(rows)
                                props?.onMultipleSelect?.(rows)
                            }}
                            onDoubleClick={(i) => props.onDoubleClick?.(i)}
                            onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                            onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                            onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                            onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                            onEnter={() => setViewState("edit")}
                        />
                    )}
        </PluginWrapper>
    )
}

export default DosageByStoreGrid